// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_vh1","cls2":"common-cls2_yND common-cls1_vh1"};